"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-sla-stereolithography";

const COLUMNS = [
	{ key: "Standard", labelKey: "slaTolerancesColStandard" },
	{ key: "High", labelKey: "slaTolerancesColHigh" },
	{ key: "General", labelKey: "slaTolerancesColGeneral" },
] as const;

const ROWS = [
	{ key: "BuildEnvelope", labelKey: "slaTolerancesRowBuildEnvelope" },
	{ key: "LayerHeight", labelKey: "slaTolerancesRowLayerHeight" },
	{ key: "ToleranceXy", labelKey: "slaTolerancesRowToleranceXy" },
	{ key: "ToleranceZ", labelKey: "slaTolerancesRowToleranceZ" },
	{ key: "MinLinear", labelKey: "slaTolerancesRowMinLinear" },
	{ key: "MinRadial", labelKey: "slaTolerancesRowMinRadial" },
] as const;

export default function GeneralTolerances() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-6 text-center text-2xl font-bold leading-tight text-black sm:mb-8 sm:text-[30px] md:mb-10 md:text-4xl lg:mb-12">
					{t("slaTolerancesTitle")}
				</h2>

				<div className="overflow-x-auto border-y border-[#cfd9a8] bg-[#f6ffde]">
					<table className="w-full min-w-[760px] border-collapse text-left">
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th className="px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("slaTolerancesColDescription")}
								</th>
								{COLUMNS.map((col) => (
									<th key={col.key} className="px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
										<div className="lg:w-[150px]">{t(col.labelKey)}</div>
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{ROWS.map((row) => (
								<tr key={row.key} className="border-t border-[#cfd2c8]">
									<th
										scope="row"
										className="px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
									>
										{t(row.labelKey)}
									</th>
									{COLUMNS.map((col) => (
										<td
											key={col.key}
											className="px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base"
										>
											{t(`slaTolerancesRow${row.key}${col.key}`)}
										</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<p className="mt-5 text-sm leading-relaxed text-black sm:mt-6 md:text-base">
					<span className="font-bold">{t("slaTolerancesNoteLabel")}</span>
					{t("slaTolerancesNoteText")}
				</p>
			</div>
		</section>
	);
}
